import Splide from '@splidejs/splide';
import Classes from '../utils/custom-classes';
import FindItems from '../utils/find-items';

export default class CarouselHero {
  constructor(scope) {
    const target = '[data-carousel-hero]';

    FindItems(scope, target, this.create);
  }

  create(element) {
    const splide = new Splide(element, {
      type: 'loop',
      drag: true,
      arrows: false,
      classes: Classes,
      fixedHeight: false,
      slideFocus: false,
      updateOnMove: true,
      autoplay: element.hasAttribute('data-carousel-autoplay') ? true : false,
      interval: element.hasAttribute('data-carousel-interval')
        ? parseInt(element.getAttribute('data-carousel-interval'), 10)
        : null
    });

    splide.on('mounted', function () {
      resetTabIndex();
    });

    splide.mount();

    splide.on('move', function () {
      resetTabIndex();
    });
  }
}

const resetTabIndex = () => {
  const link = document.querySelectorAll('li.carousel_slide a');
  const activeLink = document.querySelector('li.carousel_slide.is-active a');
  link.forEach(l => l.setAttribute('tabindex', '-1'));
  if (activeLink) activeLink.setAttribute('tabindex', '0');
};
